import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { AccountRole } from '../../Models/Domains/Account/AccountRole';

declare var IS_RUNNING_IN_APP_POOL;

export class AccountRolesClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(accountHierarchyId: string): Promise<Array<AccountRole>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/AccountRoles/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { accountHierarchyId: accountHierarchyId }

    return AjaxWrapper.get<Array<AccountRole>, any>(url, data);
  }
}

